import React, { useEffect } from 'react'
import Left_panel from '../Left_panel'
import Sub_header from '../Sub_header'
import axios from 'axios'
import exportValue from '../../apiconfig'
import Swal from 'sweetalert2';
import Modal from 'react-bootstrap/Modal';
import '../../components/loader.css';
import TablePagination from '@mui/material/TablePagination';
import { Container, Row, Col, Form, Button, ProgressBar, ModalFooter, NavItem } from "react-bootstrap"
import { useNavigate } from 'react-router-dom'
import Moment from 'react-moment'
import * as XLSX from 'xlsx'

const Payment_gateway = () => {
    let navigate = useNavigate();
    let admindata = {};
  if (localStorage.getItem('admin_login')) {
    admindata = JSON.parse(localStorage.getItem('admin_login'));
    console.log("admindata------>  -  ", admindata);

  }
    const [state, setState] = React.useState({
        transaction_list: [],
        dataCount: 0,
        isLoading: true,
        dialogOpen: false,
        searchValue: "",
       

    })
    const [focusedIndex, setfocusedIndex] = React.useState(-1);
    const inputRef = React.useRef(null);
    function todayDateString() {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      }
      
    const[date,setDate]=React.useState({start_date:todayDateString() , end_date:todayDateString()})
    const [rstate, setRState] = React.useState({
        suggestions: [],
        text: "",
        customer_id:""
      });
    const search = window.location.search;
    // console.log("search -   ",search);
    const params = new URLSearchParams(search);
    let transaction= params.get('transaction')
 
   
  const [shipmentstate, setshipStatus] = React.useState({ status: null });
const[modals,setModals] = React.useState({show: false,transaction_id:"",shipment_id:"",created:"",date:"",merchant_id:"",full_name:"",payer_email:"",payer_id:"",paid_amount:"",currency_code:"",t_uid:"",payment_method:"",status:"",service_charge:"",online_id:"",remaining_amount:"",transporter_advance:"",admin_advance:"",invoice_id:""})
const [otherStates,setOtherState] = React.useState({activePage:1,rowsPerPage:10,page:0,total_count:0,onload:true});

// const [searchfilters, setsearchFilters] = React.useState({ searchtitle: "" })
const[dimensionState,setdimensionState] = React.useState({companyDetail:[]})
const [searchfilters, setsearchFilters] = React.useState({ filterStatus:[]})
console.log("searchfilters == " , searchfilters)
const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);

const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    const homeSection = document.querySelector('.home-section');
    if (homeSection) {
        homeSection.classList.toggle('sidebar-closed');
    }
};

function selectedText(value) {
  if (!value || !value.full_name || !value.customer_id) {
    return; // Exit early if value is invalid
  }

  setRState(() => ({
    text: value.full_name,
    suggestions: [],
    customer_id:value.customer_id
  }));

}
// const dimension_detail = () =>{
//     let full_api = exportValue.host + '/' + exportValue.version + '/' + exportValue.api + `/company_info_api`;
//     let sendData = {};
  
//     axios.post(full_api, sendData, { headers: exportValue.headers }).then(res => {
//       setdimensionState({...dimensionState,companyDetail:res.data.companyDetail});
//       console.log("rnmmmmm", res);
//     }).catch((e) => {
//       // toast.configure()
//        //toast.error("Some thing went wrong")
//       console.log("----error:   ", e);
//     })
//   }
  React.useEffect(() => {
    // dimension_detail();
    customerProfile()
    axios_get_api()
   
   
  }, [])


    const axios_get_api = () => {
        //  console.log("dstatus--->",shipment_status)
      
        let full_api = exportValue.host + '/' + exportValue.version + '/' + exportValue.api + `/payment_gateway_transaction_list`;
        let sendData = {
            from_start_date: date.start_date,
            to_start_date: date.end_date,
            customer_id:rstate.customer_id,
            status:searchfilters.filterStatus,
        }
       
         console.log("send",sendData)
        axios.post(full_api, sendData, { headers: exportValue.headers }).then(res => {
            

            // if(index==0  && onLoad) {
            //     setOtherState({...otherStates,total_count:res.data.dataCount})         
            // }

           
         setState({ ...state, transaction_list: res.data.output ,isLoading:false });
          
          console.log( "response",res);
       


        }).catch((e) => {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Something went wrong!',
                
              })
            console.log("----error:   ", e);
        })

    }
  

//     const searchUser = ( status,index=0) => {
//         let full_api = exportValue.host + '/' + exportValue.version + '/' + exportValue.api + `/transaction_find_detail`;
            
//         let transporter_data= { indexValue:index, limit:otherStates.rowsPerPage, dstatus:1,transaction_id:"", status:status,};
//         // console.log("pv",state.title)
//         if ( searchfilters.searchtitle!="") {
//            transporter_data.transaction_id=  searchfilters.searchtitle;
//          }
//          console.log("transporter",transporter_data)
       
//     axios.post(full_api,transporter_data, { headers: exportValue.headers }).then(res => {        
// //    setState({ ...state,searchValue:res.data.title})
//    console.log( "response123",res);
//    if(index==0 && otherStates.onload) {
//     setOtherState({...otherStates,total_count:res.data.dataCount,onload:false})         
// }  
//    setState({ ...state, transaction_list: res.data.output, dataCount: res.data.dataCount,isLoading:false });
       
   
   

//    }).catch((e) => {
//     Swal.fire({
//         icon: 'error',
//         title: 'Oops...',
//         text: 'Something went wrong!',
        
//       })
//        console.log("----error:   ", e);
//    })          
//   }

// const stateHandler = (e) => {
//     // state[key] = value
//     if (e.target.name == "stransaction") {
      
//             params.delete('transaction')
//             transaction= null;
//           setsearchFilters({ ...searchfilters, searchtitle: e.target.value })
//             //   navigate({ search: params.toString() })

//         }
// //    setsearchFilters({ ...searchfilters, searchtitle:searchfilters.searchtitle})
//     setOtherState({...otherStates,onload:true})
// }
// const filter=()=>{
//     transaction=null
//     params.delete('transaction')
//     if (searchfilters.searchtitle !== "") {           
//         params.append('transaction', searchfilters.searchtitle)
//     }
//     searchUser(null,0)
//     // setState({ ...state, isLoading: true })
//     navigate({ search: params.toString() })

// }
// React.useEffect(()=>{
//     if (transaction) {
//         setsearchFilters({...searchfilters,searchtitle:transaction})
//     }
// // searchUser(null,0)
// // axios_get_api(null,0,true);


// },[])

    
    // const shipmentFilter = (status) => {
    //     // console.log("action ",dstatus);
    //     setshipStatus({ ...shipmentstate, status: status })
      
    //     axios_get_api(status,0,true)
        
    //   }
   
   
    //  const handlePageChange = (event,newPage) =>{
    //     // console.log("newpage",newPage)
    //     setOtherState({...otherStates,page:newPage})
    //     //console.log("newPage ", newPage);
    //     axios_get_api(shipmentstate.status,newPage);
        
    //     // searchUser(state.searchValue,newPage)
    // }
    // const handleChangeRowsPerPage = (event,newPage) => {
    //     // console.log("event ", event);
    //     setOtherState({...otherStates, rowsPerPage:+event.target.value, page:0})
       
    // }

    const modalValues = (item) =>{
        console.log(item);
        setModals(item)
    }

    const filter=(e,values)=>{
        const name = e.target.name;
        const value = values;
        const isChecked = e.target.checked;
      
        // Create a new array by spreading the existing filterStatus array
        const updatedFilterStatus = [...searchfilters.filterStatus];
      
        if (isChecked) {
          updatedFilterStatus.push(value);
        } else {
          // Remove the value from the array if unchecked
          const index = updatedFilterStatus.indexOf(value);
          if (index !== -1) {
            updatedFilterStatus.splice(index, 1);
          }
        }
      
        // Update the searchfilters state with the updated filterStatus array
        setsearchFilters((prevFilters) => ({
          ...prevFilters,
          filterStatus: updatedFilterStatus,
        }));
      }
      const customerProfile =()=>{
        let full_api = exportValue.host + '/' + exportValue.version + '/' + exportValue.api + `/customer_profile`;
        let sendData = {admin_type:admindata.admin_type , admin_id:admindata.admin_id};
      
        axios.post(full_api, sendData, { headers: exportValue.headers }).then(res => {
          setdimensionState(res.data.output);
          console.log("rnmmmmm", res);
        }).catch((e) => {
          // toast.configure()
           //toast.error("Some thing went wrong")
          console.log("----error:   ", e);
        })
     }
  
      const customerHandle =(e)=>{
        const value = e.target.value;
        let suggestions = [];
        if (value.length > 0) {
          const regex = new RegExp(`^${value}`, "i");
          suggestions = dimensionState.filter(sub =>
            (sub.email && regex.test(sub.email)) ||
            (sub.full_name && regex.test(sub.full_name))
          );
        //   suggestions = dimensionState.sort().filter((full_name) => regex.test(full_name));
          console.log("suggestions ==" , suggestions)
          setRState(() => ({
            suggestions,
            text: value,
          }));
        }
        else{
            setRState(() => ({
                text: "",
                customer_id:"",
                suggestions: [],
              }));
        }
        
       }
       
       const handleDate =(e)=>{
        setDate({...date , [e.target.name]:e.target.value})
      }
      const downloadExcel = () => {
        const data = transformDataForExcel();
        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Recharges Reports');
        XLSX.writeFile(wb, 'Recharges Table.xlsx');
      };
      const transformDataForExcel = () => {
        return state.transaction_list.map(item => {
          console.log("created == ", item.created)
          const formattedDate = item.created
            ? new Date(item.created * 1000).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'short',
              day: 'numeric',
            })
            : '';
    
          const formattedTime = item.created
            ? new Date(item.created * 1000).toLocaleTimeString('en-US', {
              hour: 'numeric',
              minute: 'numeric',
              second: 'numeric',
              hour12: true,
            })
            : '';
          return {
            'Transaction ID ': item?.transaction_id || '',
            'Mode': item?.payment_method || '',
            'Gateway ID': item.gateway_transaction_id!=undefined && item.gateway_transaction_id!=''?item.gateway_transaction_id:item.payment_discription!=undefined&& item.payment_discription.razorpay_payment_id?item.payment_discription.razorpay_payment_id:'----------',
            'Customer ID': item?.customer_id || "",
            'Customer Name': item?.full_name || '',
            'Amount (₹)': item?.amount || '',
            'Status': getStatusText(item?.payment_status) || '',
            'Date': formattedDate,
              'Time': formattedTime,
            
          }
        });
      };
      const getStatusText = (status) => {
        // Define your status mappings here
        const statusMappings = {
          0: 'Pending',
         1: 'Success',
          };
          return statusMappings[status] || '';
    }
    const handleKeyDown = (e) => {
      if (rstate.suggestions.length === 0) return;
    
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        const nextIndex = (focusedIndex + 1) % rstate.suggestions.length;
        setfocusedIndex(nextIndex);
      } 
      else if (e.key === 'ArrowUp') {
        e.preventDefault();
        const prevIndex = (focusedIndex - 1 + rstate.suggestions.length) % rstate.suggestions.length;
        setfocusedIndex(prevIndex);
      } 
      else if (e.key === 'Enter') {
        e.preventDefault();
    
        const selectedItem = 
          focusedIndex !== -1 ? rstate.suggestions[focusedIndex] : rstate.suggestions[0];
    
        if (selectedItem) {
          selectedText(selectedItem);
        }
      }
    };
  return (
    <div>
        
        <Left_panel isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
       
       <section class="home-section">
               {/* <?php
               include('sub_header.php');
               ?> 
            */}
       <Sub_header/>    


              <div class="row mb-3 mt-3">
            <div class="col-12 col-md-2">
                <h5>Wallet Transaction List</h5>
            </div>
            <div class="col-12 col-md">
                <div class="row">
                <div className="col-12 col-md-4 position-relative">
                  <input
                    type="text"
                    name="customer_name"
                    className="form-control"
                    placeholder="Enter Customer Name"
                    onChange={customerHandle}
                    value={rstate.text}
                    autoComplete="off"
                    onKeyDown={handleKeyDown}
                    ref={inputRef}
                  />
                
                  {rstate.suggestions.length > 0 && (
                    <ul className="list-group position-absolute w-100 z-3" style={{ maxHeight: "200px", overflowY: "auto", top: "100%" }}>
                      {rstate.suggestions.map((item, index) => (
                        <li
                          key={index}
                          onClick={() => selectedText(item)}
                          className={`list-group-item list-group-item-action ${index === focusedIndex ? 'active' : ''}`}
                          style={{
                            cursor: "pointer",
                            fontSize: "14px",
                            padding: "8px 15px",
                          }}
                        >
                          <strong>{item.full_name}</strong> <br />
                          <small className="text-muted">{item.email}</small>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
                    <div class="col-12 col-md">
                    <div class="btn-group">
                   <button type="button" class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown"><i class="fa fa-filter" aria-hidden="true"></i> &nbsp;
                       All Status <i class="fa fa-angle-down" aria-hidden="true"></i>
                   </button>
                   <div class="dropdown-menu">
                       <section class="p-2">
                       <h6>All Status</h6>
                       <hr/>
                           {/* <div class="form-check">
                               <input class="form-check-input" type="checkbox" id="check1" name="all" value="something"  onChange={(e)=>filter(e,null)}/>
                               <label class="form-check-label">All</label>
                           </div> */}
                           <div class="form-check">
                               <input class="form-check-input" type="checkbox" id="check1" name="success" value="something" onChange={(e)=>filter(e,1)}/>
                               <label class="form-check-label">Success</label>
                           </div>
                           <div class="form-check">
                               <input class="form-check-input" type="checkbox" id="check1" name="pending" value="something"  onChange={(e)=>filter(e,0)}/>
                               <label class="form-check-label">Pending</label>
                           </div>
                         </section>
                     
                   </div>
                 </div>
                    </div>
                    <div class="col-12 col-md-2">
                        <input type="date" class="form-control" id="text" placeholder="select date range" value={date.start_date} name="start_date" onChange={(e)=>handleDate(e)}/>
                    </div>
                    <div class="col-12 col-md-2">
                        <input type="date" class="form-control" id="text" placeholder="select date range" value={date.end_date} name="end_date" onChange={(e)=>handleDate(e)}/>
                    </div>
                    <div class="col-12 col-md-2 text-end">
                        <div class="d-grid">
                          <a  class="btn btn-primary btn-block" onClick={(e)=>axios_get_api()}>Get Report</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
            {/* <section>
                <ul class="nav nav-tabs justify-content-end">
                    <li class="nav-item">
                      <a class={(shipmentstate.status == null)?"nav-link active":"nav-link"} onClick={()=>shipmentFilter(null)}>All</a>
                    </li>
                    <li class="nav-item">
                      <a class={(shipmentstate.status == 1)?"nav-link active":"nav-link"}  onClick={()=>shipmentFilter(1)}>Success</a>
                    </li>
                    <li class="nav-item">
                      <a class={(shipmentstate.status == 0)?"nav-link active":"nav-link"}  onClick={()=>shipmentFilter(0)}>Pending</a>
                    </li>
                   
                    
                </ul>
            </section> */}
            <div class="card card-body border-0 shadow table-wrapper table-responsive">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th class="border-gray-200">Initiated</th>
                            <th class="border-gray-200">Transaction ID</th>
                            <th class="border-gray-200">Mode</th>	
                            <th class="border-gray-200">Gateway ID #</th>						
                            <th class="border-gray-200">Customer ID #</th>
                          	 <th class="border-gray-200">Customer Name</th>
                            <th class="border-gray-200">Amount</th>
                            <th class="border-gray-200">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {/* <!-- Item --> */}
                        {state.transaction_list.map((item)=>
                        <tr>
                            <td>
                                <span class="fw-normal">
                                    <small><Moment format="MMM DD YYYY hh:mm">
                        {new Date(item.created*1000)}</Moment> <br/>
                                    {/* 5 months ago */}
                                    </small>
                                </span>
                            </td>
                            <td>
                                <a href="" data-bs-toggle="modal" data-bs-target="#modal-transaction-payment" class="fw-700 text-info" onClick={()=>modalValues(item)} data-bs-backdrop="false">{item.transaction_id}</a>
                            </td>
                            {/* <td>
                                <span class="fw-bold">{item.payment_method} </span><br/>
                                     <small>{item.gateway_transaction_id}</small>
                            </td> */}
                            <td>
                               <small>{item.payment_method}</small><br/>
                               <small className='text-danger'>{item.payer_id!=undefined && item.payer_id!=''?item.payer_id:""}</small>
                                {/* <a href={"/shipment_detail/"+item.shipment_id} class="fw-700 text-info">{item.shipment_id}</a> */}
                            </td>
                            <td>
                                {/* <a href={"/customers_info/"+item.customer_id} class="fw-700 text-info">
                                   {item.full_name}
                                </a> */}
                                <small>{item.gateway_transaction_id!=undefined && item.gateway_transaction_id!=''?item.gateway_transaction_id:item.payment_discription!=undefined&& item.payment_discription.razorpay_payment_id?item.payment_discription.razorpay_payment_id:'----------'}</small>
                            </td>  
                            <td>
                                <small>{item.customer_id}</small>
                           </td> 
                           <td>
                                <small>{item.full_name}</small>
                           </td>                      
                            <td>
                                <span class="fw-bold text-danger">
                                ₹ {item.amount} 
                                </span> <br/>
                                {/* <small>
                                    $15.00 + 10.00
                                </small> */}
                            </td>
                            <td>
                                {(item.payment_status == 0)?
                                <span class="badge rounded-pill bg-warning">Pending</span>:(item.status == 1)?
                                <span class="badge rounded-pill bg-primary">Success</span>:(item.payment_status ==3)?
                                <span class="badge rounded-pill bg-success">Cancelled</span>: (item.payment_status==1)?<span class="badge rounded-pill bg-primary">Success</span>:""
                                    }
                                </td>
                        </tr>
                        )}
                                                    
                    </tbody>
                </table>
                <div class="mt-3 text-end">
                <a onClick={downloadExcel} class="btn btn-outline-primary">Download Report</a>
            </div>
                {/* <TablePagination
                            component="div"
                            rowsPerPageOptions={[5, 10]}
                            count={otherStates.total_count}
                            page={otherStates.page}
                            onPageChange={handlePageChange}
                            rowsPerPage={otherStates.rowsPerPage}
                            onRowsPerPageChange={handleChangeRowsPerPage}

                        /> */}
                {/* <div class="card-footer px-3 border-0 d-flex flex-column flex-lg-row align-items-center justify-content-between">
                    <nav aria-label="Page navigation example">
                        <ul class="pagination mb-0">
                            <li class="page-item">
                                <a class="page-link" href="#">Previous</a>
                            </li>
                            <li class="page-item">
                                <a class="page-link" href="#">1</a>
                            </li>
                            <li class="page-item active">
                                <a class="page-link" href="#">2</a>
                            </li>
                            <li class="page-item">
                                <a class="page-link" href="#">3</a>
                            </li>
                            <li class="page-item">
                                <a class="page-link" href="#">4</a>
                            </li>
                            <li class="page-item">
                                <a class="page-link" href="#">5</a>
                            </li>
                            <li class="page-item">
                                <a class="page-link" href="#">Next</a>
                            </li>
                        </ul>
                    </nav>
                    <div class="fw-normal small mt-4 mt-lg-0">Showing <b>5</b> out of <b>25</b> entries</div>
                </div> */}
            </div> 
                    

    </section>

    <section>
        {/* <!-- Modal Content --> */}
        <div class="modal fade" id="modal-transaction-payment" tabindex="-1" role="dialog" aria-labelledby="modal-transaction-payment" aria-hidden="true" data-bs-backdrop="false">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h2 class="h6 modal-title">Transaction #{modals.transaction_id}</h2>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <table class="table">
                            <tbody>
                              <tr>
                                <td class="fw-700 text-dark">Date</td>
                                <td><Moment format="YYYY-MM-DD hh:mm">
                        {new Date(modals.created*1000)}</Moment></td>
                              </tr>
                              <tr>
                                <td class="fw-700 text-dark">Transaction ID</td>
                                <td>{modals.transaction_id}</td>
                              </tr>
                              <tr>
                                <td class="fw-700 text-dark">User name</td>
                                <td>{modals.full_name}</td>
                              </tr>
                              <tr>
                                <td class="fw-700 text-dark">Method</td>
                                <td>{modals.payment_method}</td>
                              </tr>
                              <tr>
                                <td class="fw-700 text-dark">Send to email</td>
                                <td>{modals.email}</td>
                              </tr>
                              <tr>
                                <td class="fw-700 text-dark">Amount</td>
                                <td>{modals.amount}</td>
                              </tr>
                              {/* <tr>
                                <td class="fw-700 text-dark">Charge</td>
                                <td>{modals.payment_method}</td>
                              </tr>
                              <tr>
                                <td class="fw-700 text-dark">Payable</td>
                                <td>{modals.payment_method}</td>
                              </tr> */}
                              <tr>
                                <td class="fw-700 text-dark">Status</td>
                                <td>{(modals.payment_status == 0)?<span class="badge bg-warning">Pending</span>:(modals.status == 1)?<span class="badge bg-success">Success</span>:(modals.status == 3)?<span class="badge bg-success">Cancelled</span>:""}</td>
                              </tr>
                            </tbody>
                          </table>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-link text-gray-600 ms-auto" data-bs-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
        {/* // <!-- End of Modal Content --> */}
    </section>


    </div>
  )
}

export default Payment_gateway
